import { render, staticRenderFns } from "./CoordinatorIcon.vue?vue&type=template&id=82151a64&"
import script from "./CoordinatorIcon.vue?vue&type=script&lang=js&"
export * from "./CoordinatorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports